import { MESSAGE_STATUS } from '@engyalo/design-system/dist/src/MessageBubble/types';

type StatusArgs = { pending?: boolean; delivered?: boolean; read?: boolean };

type IconConditionPair = [(args: StatusArgs) => boolean, `${MESSAGE_STATUS}`];

const statusIconRules: IconConditionPair[] = [
  [({ pending }) => Boolean(pending), 'pending'],
  [({ delivered }) => Boolean(delivered), 'received'],
  [({ read }) => Boolean(read), 'received'],
];

export const getMessageStatus = ({ pending, delivered, read }: StatusArgs): `${MESSAGE_STATUS}` => {
  const [, status] = statusIconRules.find(([validate]) => validate({ pending, delivered, read })) || [];
  return status || 'sent';
};
